import axios, { microServices } from './axios'

export const getItemStock = async (itemId) => {
    return await axios('get', `/inventory/stock/${itemId}`,
        {}, {
        server: microServices.DE_CORE
    }).then(data => {
        return data
    },
        error => { // request level error
            return new Promise((resolve, reject) => {
                reject(error)
            })
        })
}
